<template>
  <el-dialog :visible.sync="show" title="三元组选择框" :before-close="closeDialog" width="900px">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="assetsCode" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="getData()">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>
    <el-table border v-loading="loading" :data="tableData" highlight-current-row @current-change="handleTripletChange"
      header-cell-class-name="table-header-cell">
      <el-table-column label="选择" width="55" align="center">
        <template slot-scope="{row}">
          <el-radio v-model="selectedId" :label="row.ID"><span></span></el-radio>
        </template>
      </el-table-column>
      <el-table-column label="出厂编码" prop="FactoryCode" show-overflow-tooltip></el-table-column>
      <el-table-column label="资产码" prop="assetsCode" show-overflow-tooltip></el-table-column>
      <el-table-column label="枪个数" prop="Count"></el-table-column>
      <el-table-column label="交直流类型" prop="TypeName"></el-table-column>
      <el-table-column label="设备类型" prop="DeviceType"></el-table-column>
      <el-table-column label="是否已使用" prop="IsAdd">
        <template slot-scope="{row}">
          <el-tag v-if="row.IsAdd" type="primary">是</el-tag>
          <el-tag v-else type="info">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="State">
        <template slot-scope="{row}">
          <el-tag type="success" v-if="row.State == 1">启用</el-tag>
          <el-tag type="danger" v-else>禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="CreateTime" width="160px"></el-table-column>
    </el-table>
    <div class="my-pagination">
      <el-pagination background layout="total,prev,pager,next" :total="pageParams.total" :page-size="pageParams.limit"
        :page-sizes="[10, 20, 30, 40, 50]" :current-page="pageParams.page" @size-change="handleSizeChange"
        @current-change="handleCurrentChange"></el-pagination>
    </div>
    <span slot="footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button @click="comfirmDialog" type="primary">确定并关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { GetTripletPageList } from "@/api/dev_archive";
import pageMixin from '@/mixins/cptMixin.js';
import { ChartView } from "echarts";
export default {
  mixins: [pageMixin],
  data() {
    return {
      loading: false,
      tableData: [],
      typename: "",
      is_tjtf: "",
      selectItem: '',
      assetsCode: "",
      pageParams: {
        page: 1,
        limit: 10,
        total: 0
      },
      selectedId: ''
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    deviceType: {
      type: [String, Number],
      default: ""
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.typename = this.deviceType;
        this.getData();
      } else {
        this.selectItem = '';
        this.selectedId = '';
      }
    }
  },
  methods: {
    comfirmDialog() {
      if (!this.selectItem) {
        this.$message.error('请先选择数据');
        return;
      }
      if (this.selectItem.State == 0) {
        this.$message.error('此三元组已被禁用，请重新选择');
        return;
      }
      this.$emit('confirm', this.selectItem);
    },
    getData() {
      this.loading = true;

      if (this.typename == "1") {
        this.is_tjtf = 1
        this.typename = ""
      }
      GetTripletPageList({
        page: this.pageParams.page,
        limit: this.pageParams.limit,
        typename: this.typename,
        assetsCode: this.assetsCode,
        is_tjtf: this.is_tjtf
      }).then(res => {
        this.tableData = res.data;
        this.pageParams.total = Number(res.total);
      }).finally(() => { this.loading = false; });

    },
    closeDialog() {
      this.$emit('update:show', false);
    },
    handleTripletChange(val) {
      if (val) {
        this.selectedId = val.ID;
        this.selectItem = val;
      }
    }
  }
}
</script>